export const BIOMETRICS_MOCK = {
  UNLIMITED: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJiYmEzNzEyMC02ZWM4LTExZWYtYjRlNi1kZjY4NjlmYmJkOWNlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImRkZjc3NGE0MTdmNTZjMzUxZDU2ZTM4NWViMDI0MmRiYzg0ZDQzNmYwYjI5ODQyMTA1OWIwN2E2OTIyNjFlYWEifQ.C3JUfnMZhYR0i99xIus3zKobpI1HosRaPAhsvO1D3fY',
    status: 'pending',
  },
  MAX_ATTEMPTS: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJiMDJmMDM0MC04MWE2LTExZWYtOWMyZi1lNWU0MmZhMjRiYTJlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImI4NjlkNjhiNWFkYzNmOWU3YjQyNjE4MDQ1N2QzYjQ0MWUzYzAwM2RhYjA0Mjg0ZTIwZjkxZjJiMjE3NzdhNDYifQ.GoKK1cyIOMvqAqHWE3YS10hO9hbw0qpXFo-IiA1pPqE',
    status: 'pending',
  },
  CANCEL: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJiYmEzNzEyMC02ZWM4LTExZWYtYjRlNi1kZjY4NjlmYmJkOWNlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImRkZjc3NGE0MTdmNTZjMzUxZDU2ZTM4NWViMDI0MmRiYzg0ZDQzNmYwYjI5ODQyMTA1OWIwN2E2OTIyNjFlYWEifQ.C3JUfnMZhYR0i99xIus3zKobpI1HosRaPAhsvO1D3fY',
    status: 'cancel',
  },
  FINISHED: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJiYmEzNzEyMC02ZWM4LTExZWYtYjRlNi1kZjY4NjlmYmJkOWNlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImRkZjc3NGE0MTdmNTZjMzUxZDU2ZTM4NWViMDI0MmRiYzg0ZDQzNmYwYjI5ODQyMTA1OWIwN2E2OTIyNjFlYWEifQ.C3JUfnMZhYR0i99xIus3zKobpI1HosRaPAhsvO1D3fY',
    status: 'finished',
  },
  ERROR: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJiYmEzNzEyMC02ZWM4LTExZWYtYjRlNi1kZjY4NjlmYmJkOWNlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImRkZjc3NGE0MTdmNTZjMzUxZDU2ZTM4NWViMDI0MmRiYzg0ZDQzNmYwYjI5ODQyMTA1OWIwN2E2OTIyNjFlYWEifQ.C3JUfnMZhYR0i99xIus3zKobpI1HosRaPAhsvO1D3fY',
    status: 'error',
  },
  NEW: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjaWQiOiJkYTAzYTRkMC04MjkzLTExZWYtYTkyNi0yMTgzOTlmMzAzOGJlMSIsInRva2VuX3VzZSI6InNpZ24iLCJpc3MiOiJodHRwczovL2FwaS5zdGcua2V5bnVhLmNvbS9jb250cmFjdHMiLCJ1aWQiOjAsInBpZCI6ImRkZjc3NGE0MTdmNTZjMzUxZDU2ZTM4NWViMDI0MmRiYzg0ZDQzNmYwYjI5ODQyMTA1OWIwN2E2OTIyNjFlYWEifQ.z99OosJiRCpLsXN5CNr9lClsBfjHvXiJJYuxdilg680',
    status: 'pending',
  },
};
